import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GoogleMapsService } from '../../_services/google-maps.service';

@Component({
  selector: 'app-address-search',
  standalone: false,
  templateUrl: './address-search.component.html',
  styleUrl: './address-search.component.css'
})
export class AddressSearchComponent implements AfterViewInit  {
  @ViewChild('  ') addressInput!: ElementRef;
  placePhotoUrl: string | null = null;
  predictions: any[] = [];
  searchQuery = '';

  constructor(private mapsService: GoogleMapsService) {}

  ngAfterViewInit() {
    this.mapsService.initAutocomplete(this.addressInput.nativeElement);
    this.mapsService.getPlacePhoto().subscribe(photoUrl => {
      this.placePhotoUrl = photoUrl;
    });
  }
 
  onSearchChange(event: any): void {
    if (this.searchQuery.length > 2) {
      this.mapsService.getPlacePredictions(this.searchQuery).subscribe(
        predictions => this.predictions = predictions,
        error => console.error(error)
      );
    }
  }

  selectPrediction(prediction: any): void {
    this.mapsService.getPlaceDetails(prediction.place_id).subscribe(
      details => {
        console.log('Detalles del lugar:', details);
      },
      error => console.error(error)
    );
  }  
}
